// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3H1cr","fileBtn":"File_fileBtn__3qiLS","closeBtn":"File_closeBtn__2PtuA","fileSelected":"File_fileSelected__27VDW","disabled":"File_disabled__7drSQ"};